import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope';
import '@fontsource/ibm-plex-mono/400.css';
import './index.css';
import App from './App';
import GlobalStyles from '@mui/material/GlobalStyles';
import { globalStyles } from './theme';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { captureReferralFromUrl } from './utils/referral';
import { captureInviteFromUrl } from './utils/invite';

// Must run before Auth0 can redirect: the login round trip returns to the bare
// origin, so `?ref=CODE` is gone by the time any component mounts.
captureReferralFromUrl();
// Same for an invitation link opened while signed out (enterprise batch 8).
captureInviteFromUrl();

const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: audience
    }}
  >
    <React.StrictMode>
      <GlobalStyles styles={globalStyles} />
      <App />
    </React.StrictMode>
  </Auth0Provider>
);

reportWebVitals();
